import mqtt from "mqtt/dist/mqtt";

const hostPort = process.env.REACT_APP_MQTT_HOST;
export const MQTTI = () => {
  const options = {
    // Clean session
    clean: true,
    // Auth
    username: process.env.REACT_APP_MQTT_USER,
    password: process.env.REACT_APP_MQTT_PASSWORD,
  };
  return mqtt.connect(hostPort, options);
};

export default function MQTTInstance() {
  // console.log("Run mqtt instance", hostPort)
}
